export const setParamValue = (prevParams, name, value) => {
  const index = prevParams.findIndex(p => p.name === name);

  const param = {
    ...prevParams[index],
    name,
    value,
  };

  const params = index === -1 ? prevParams.concat(param) : prevParams.set(index, param);
  return params;
};

export const applyParamValues = (prevParams, newParams) => newParams.map((p) => {
  const param = prevParams.find(st => st.name === p.name);

  if (param && param.value) {
    return {
      ...p,
      value: param.value,
    };
  }

  return p;
});
